import { registerCacheInvalidator } from '../offline/cache-invalidation';
import { coachApi } from './coachApi';
import { store } from './index';

export function setupCacheInvalidation(): () => void {
  registerCacheInvalidator((tags) => {
    store.dispatch(coachApi.util.invalidateTags(tags));
  });
  return () => registerCacheInvalidator(null);
}